module.exports = __webpack_public_path__ + "static/media/bb_slogan_mix.28c3def7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bb_slogan_mix.svg
// module id = 84
// module chunks = 0